import { render, staticRenderFns } from "./SubmenuBackButton.vue?vue&type=template&id=4d99308e&"
import script from "./SubmenuBackButton.vue?vue&type=script&lang=ts&"
export * from "./SubmenuBackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports